<script setup lang="ts">
/** A message the pharmacist sent in the schedule thread. */
defineProps<{
    content: string;
}>();
</script>

<template>
  <div class="max-w-[85%] self-end whitespace-pre-line rounded-lg bg-primary px-3 py-1.5 text-xs leading-snug text-white">
    {{ content }}
  </div>
</template>
